import React, { FC } from 'react'
import { useHistory } from 'react-router'

// Constants
import { routes } from '@sketch/constants'

// Icons
import { icons } from './icons'

// Components
import { Dropdown } from '@sketch/components'
import UserNavbarSection from 'modules/user/components/UserNavbarSection'
import { LinkItem } from 'modules/projects/components/Item'

// Local Components
import HelpMenu from './components/HelpMenu'

// Styles
import {
  NoWorkspacesAvatar,
  NoWorkspacesDropdown,
  NoWorkspacesIcon,
  NoWorkspacesTitle,
} from './NoWorkspaceSidebar.styles'

import {
  SidebarWrapper,
  MenuWrapper,
  StyledPill,
  WorkspaceSelectorWrapper,
  FooterWrapper,
} from './Sidebar.styles'

// Types
import { useGetInitialUserQuery } from '@sketch/gql-types'

// Helpers
import { menuItemsText } from './menuItems'
import BottomMenu from './components/BottomMenu/BottomMenu'
import { useFlag } from 'containers/flags'

export const NoWorkspaceSidebar: FC = () => {
  const history = useHistory()

  /**
   * Sidebar FF clean up
   * https://github.com/sketch-hq/Cloud/issues/15634
   */
  const isSidebarFFOn = useFlag('sidebar')

  const { data: userData } = useGetInitialUserQuery()

  const showUnseenNotificationBadge =
    userData?.me.hasUnseenNotifications ?? false

  const isPartner = userData?.me.isPartner

  return (
    <SidebarWrapper>
      <WorkspaceSelectorWrapper>
        <NoWorkspacesDropdown
          isPartner={isPartner}
          onClick={() => {
            if (!isPartner) {
              history.push(routes.WORKSPACE_CREATE.create({}))
            }
          }}
        >
          <NoWorkspacesAvatar />
          <NoWorkspacesTitle>No Workspaces</NoWorkspacesTitle>
          <NoWorkspacesIcon>
            <Dropdown.Chevrons />
          </NoWorkspacesIcon>
        </NoWorkspacesDropdown>
      </WorkspaceSelectorWrapper>
      <MenuWrapper>
        <LinkItem
          icon={icons.BellIcon}
          text={menuItemsText.updates}
          to={routes.UPDATES.create({})}
          additional={
            showUnseenNotificationBadge && (
              <StyledPill variant={{ kind: 'secondary' }}>New</StyledPill>
            )
          }
        />
        <HelpMenu />
      </MenuWrapper>
      <FooterWrapper>
        {isSidebarFFOn && <BottomMenu />}
        <UserNavbarSection />
      </FooterWrapper>
    </SidebarWrapper>
  )
}
